import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import GlobalErrorBoundary from '@commons/ErrorBoundary';
import { getNavTree } from '@src/commons/features';
import { LOGIN_MODULE_PATHS, CLIENTS_MODULE_PATHS } from '@src/commons/features/utils/modulePaths';

import './App.css';

import Login from './Login';
import Secure from './Secure';

const App = () => {
  const navTree = getNavTree();

  const router = createBrowserRouter([
    {
      errorElement: <GlobalErrorBoundary />,
      children: [
        ...navTree,
        {
          path: LOGIN_MODULE_PATHS.LOGIN,
          element: <Login />
        },
        {
          path: '*',
          element: <Navigate to="/login" replace />
        }
      ]
    },
    {
      element: <Secure />,
      errorElement: <GlobalErrorBoundary />,
      children: [
        {
          element: <Navigate to={CLIENTS_MODULE_PATHS.CLIENTS} replace />
        }
      ]
    }
  ]);

  return <RouterProvider router={router} />;
};

export default App;
